import { render } from "./MultiValueCard.vue?vue&type=template&id=a995d3c0&scoped=true"
import script from "./MultiValueCard.vue?vue&type=script&lang=js"
export * from "./MultiValueCard.vue?vue&type=script&lang=js"

import "./MultiValueCard.vue?vue&type=style&index=0&id=a995d3c0&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a995d3c0"]])

export default __exports__